import React from 'react';
import EmailForm from 'pages/admin/email/form/EmailForm';

const EmailCreate = () => {
    return <EmailForm />;
};

export default EmailCreate;
